export const drumKits = {
  "1": "Standard Drum Kit",
  "9": "Room Drum Kit",
  "17": "Power Drum Kit",
  "25": "Electric Drum Kit",
  "26": "TR-808 Drum Kit",
  "33": "Jazz Drum Kit",
  "41": "Brush Drum Kit",
  "49": "Orchestra Drum Kit",
  "57": "Sound FX Drum Kit"
}
